'use strict';
const _ = require('underscore'),
	mmWidgets = require('./mm-widgets');
mmWidgets.fn.progressCalcWidget = function (progressModel) {
	return mmWidgets.each(this, function () {
		const element = mmWidgets(this),
			table = element.find('[data-mm-role~=calc-table]'),
			calcRowTemplate = element.find('[data-mm-role~=row-template]').detach().attr('data-mm-role', 'data-row'),
			totalElement = element.find('[data-mm-role~=total]'),
			msgDiv = element.find('[data-mm-role~=empty]'),
			totalValueElement = totalElement.find('[data-mm-role~=total-value]'),
			cellTemplate = calcRowTemplate.find('[data-mm-role~=cell]').detach(),
			repopulateTable = function (data) {
				const tbody = table.find('tbody');
				tbody.empty();
				if (_.isEmpty(data)) {
					table.addClass('hidden');
					msgDiv.removeClass('hidden');
					totalElement.addClass('hidden');
				} else {
					table.removeClass('hidden');
					msgDiv.addClass('hidden');
					if (data.total) {
						totalValueElement.text(data.total().toLocaleString());
						totalElement.removeClass('hidden');
					} else {
						totalElement.addClass('hidden');
					}
					_.each(data, function (row) {
						const rowDOM = calcRowTemplate.clone().appendTo(tbody);
						_.each(row, function (cell, index) {
							const cellDOM = cellTemplate.clone().addClass('cell' + index).appendTo(rowDOM);
							cellDOM.find('[data-mm-role=value]').text(cell.toLocaleString());
						});
					});
				}
			};
		progressModel.addEventListener('progressContext', function (context) {
			if (context.isActive) {
				progressModel.addEventListener('dataUpdated', repopulateTable);
			} else {
				progressModel.removeEventListener('dataUpdated', repopulateTable);
			}
		});


	});
};
